import { get as _get } from './common';
import { inventoryActiveOwnerDuck, lscOwnerDuck } from '../ducks';
import fetchLscOwner from '../fetchers/fetchLscOwner';

const getLscOwner = async (query, state) => {
    const dealerId = _get(query, 'dealerId');
    const zipCode = _get(query, 'zip');
    const activeOwner = inventoryActiveOwnerDuck.selectors.getDuckState(state);
    const ownerId = dealerId || activeOwner;
    const lscOwner = lscOwnerDuck.selectors.getDuckState(state);
    if (lscOwner?.id === ownerId) {
        return { status: 'ok', owner: lscOwner };
    }
    return fetchLscOwner(ownerId, zipCode);
};

export default getLscOwner;
